import React, { useState } from 'react';
import './PaymentSuccessModal.css';
import PrintInvoice from '../order/PrintInvoice';

interface PaymentSuccessModalProps {
  isVisible: boolean;
  orderData: any;
  onClose: () => void;
}

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({ isVisible, orderData, onClose }) => {
  const [showPrintInvoice, setShowPrintInvoice] = useState(false);

  if (!isVisible) return null;

  console.log('PaymentSuccessModal orderData:', orderData);
  console.log('orderData.mergedTables:', orderData?.mergedTables);
  console.log('orderData.mergedOrders:', orderData?.mergedOrders);
  console.log('orderData.tableId:', orderData?.tableId);
  console.log('orderData.change:', orderData?.change, 'type:', typeof orderData?.change);
  console.log('orderData.amountPaid:', orderData?.amountPaid, 'type:', typeof orderData?.amountPaid);
  
  console.log('All orderData fields that might show 0:');
  console.log('- total:', orderData?.total);
  console.log('- subtotal:', orderData?.subtotal);
  console.log('- tax:', orderData?.tax);
  console.log('- discount:', orderData?.discount);
  console.log('- amountPaid:', orderData?.amountPaid);
  console.log('- change:', orderData?.change);
  console.log('- taxRate:', orderData?.taxRate);
  console.log('- items.length:', orderData?.items?.length);
  
  console.log('All orderData fields:', Object.keys(orderData || {}));
  console.log('Full orderData object:', orderData);

  const handlePrintInvoice = () => {
    setShowPrintInvoice(true);
  };

  const handleClosePrintInvoice = () => {
    setShowPrintInvoice(false);
  };

  return (
    <>
      <div className="payment-success-overlay">
        <div className="payment-success-modal">
          <div className="payment-success-icon">✅</div>
          <h2 className="payment-success-title">Thanh toán thành công!</h2>
          
          <div className="payment-success-details">
            {orderData?.isGroupOrder ? (
              <>
                <div className="payment-success-item">
                  <span className="label">Loại thanh toán:</span>
                  <span className="value">Đặt món nhóm ({orderData?.groupInfo?.orderCount} người)</span>
                </div>
                
                <div className="payment-success-item">
                  <span className="label">Session Code:</span>
                  <span className="value">{orderData?.groupInfo?.sessionCode}</span>
                </div>
                
                <div className="payment-success-item">
                  <span className="label">Người thanh toán:</span>
                  <span className="value">{orderData?.groupInfo?.paidBy}</span>
                </div>
                
                <div className="payment-success-item">
                  <span className="label">Mã đơn hàng gộp:</span>
                  <span className="value">#{orderData?._id?.slice(-6)?.toUpperCase()}</span>
                </div>
              </>
            ) : orderData?.isMerged ? (
              <>
                <div className="payment-success-item">
                  <span className="label">Loại thanh toán:</span>
                  <span className="value">Gom bàn ({orderData?.orderCount} đơn hàng)</span>
                </div>
                
                <div className="payment-success-item">
                  <span className="label">Mã đơn hàng gộp:</span>
                  <span className="value">#{orderData?._id?.slice(-6)?.toUpperCase()}</span>
                </div>
                
                {orderData?.mergedOrders && (
                  <div className="payment-success-item">
                    <span className="label">Đơn hàng đã gom:</span>
                    <span className="value">
                      {orderData.mergedOrders.map((order: any) => 
                        '#' + order._id.slice(-6).toUpperCase()
                      ).join(', ')}
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className="payment-success-item">
                <span className="label">Mã đơn hàng:</span>
                <span className="value">#{orderData?._id?.slice(-6)?.toUpperCase()}</span>
              </div>
            )}
            
            <div className="payment-success-item">
              <span className="label">Tổng tiền:</span>
              <span className="value amount">{orderData?.total?.toLocaleString('vi-VN')}đ</span>
            </div>
            
            {orderData?.amountPaid && orderData.amountPaid > 0 && (
              <div className="payment-success-item">
                <span className="label">Tiền khách đưa:</span>
                <span className="value">{orderData.amountPaid.toLocaleString('vi-VN')}đ</span>
              </div>
            )}
            
            {orderData?.change !== undefined && orderData.change !== null && orderData.change > 0 && (
              <div className="payment-success-item">
                <span className="label">Tiền thối lại:</span>
                <span className="value change">{orderData.change.toLocaleString('vi-VN')}đ</span>
              </div>
            )}
            
            <div className="payment-success-item">
              <span className="label">Bàn:</span>
              <span className="value">
                {(() => {
                  console.log('Debug table display:');
                  console.log('- mergedTables:', orderData?.mergedTables);
                  console.log('- mergedOrders:', orderData?.mergedOrders);
                  console.log('- tableId:', orderData?.tableId);
                  console.log('- tableId type:', typeof orderData?.tableId);
                  console.log('- tableId name:', orderData?.tableId?.name);
                  
                  if (orderData?.mergedTables && orderData.mergedTables.length > 0) {
                    const tableNames = orderData.mergedTables.map((table: any) => table.name);
                    console.log('- Using mergedTables:', tableNames);
                    return tableNames.join(', ');
                  }
                  
                  if (orderData?.mergedOrders && orderData.mergedOrders.length > 0) {
                    const tableNames = orderData.mergedOrders.map((order: any) => {
                      if (typeof order.tableId === 'object' && order.tableId?.name) {
                        return order.tableId.name;
                      }
                      return order.tableId || 'N/A';
                    });
                    console.log('- Using mergedOrders:', tableNames);
                    return tableNames.join(', ');
                  }
                  
                  if (orderData?.tableId) {
                    if (typeof orderData.tableId === 'object' && orderData.tableId?.name) {
                      console.log('- Using tableId.name:', orderData.tableId.name);
                      return orderData.tableId.name;
                    } else if (typeof orderData.tableId === 'string') {
                      console.log('- Using tableId string:', orderData.tableId);
                      if (orderData.tableId.length === 24) {
                        console.log('- tableId looks like ObjectId, showing N/A');
                        return 'N/A';
                      }
                      return orderData.tableId;
                    }
                  }
                  
                  console.log('- No table info found, showing N/A');
                  return 'N/A';
                })()}
              </span>
            </div>
          </div>
          
          <div className="payment-success-message">
            {orderData?.isGroupOrder 
              ? `Cảm ơn quý khách! Đã thanh toán thành công đơn hàng nhóm với ${orderData.groupInfo?.orderCount} người.`
              : orderData?.isMerged 
                ? `Cảm ơn quý khách! Đã thanh toán thành công ${orderData.orderCount} đơn hàng.`
                : 'Cảm ơn quý khách đã sử dụng dịch vụ!'
            }
          </div>
          
          <div className="payment-success-buttons">
            <button className="payment-success-print-btn" onClick={handlePrintInvoice}>
              🖨️ In hóa đơn
            </button>
            <button className="payment-success-close-btn" onClick={onClose}>
              Đóng
            </button>
          </div>
        </div>
      </div>

      {showPrintInvoice && (
        <PrintInvoice 
          orderData={orderData} 
          onClose={handleClosePrintInvoice} 
        />
      )}
    </>
  );
};

export default PaymentSuccessModal; 